import React from "react";
import styles from "./NavBar.module.css";

type NavbarProps = {
    reports: { name: string; key: string }[];
    activeReport: string;
    onSelect: (key: string) => void;
};

const Navbar: React.FC<NavbarProps> = ({ reports, activeReport, onSelect }) => {
    return (
        <nav className={styles.navbar}>
            {reports.map((r) => (
                <button
                    key={r.key}
                    onClick={() => onSelect(r.key)}
                    className={`${styles.navbarButton} ${
                        activeReport === r.key ? styles.active : styles.inactive
                    }`}
                >
                    {r.name}
                </button>
            ))}
        </nav>
    );
};

export default Navbar;
